import styled from 'styled-components';
import Row from '../../Row';

const CardRow = styled(Row)`
    justify-content: space-between;
`;

export default CardRow;
